import axios from 'axios';
import API_CONFIG from '../config/apiConfig';

const api = axios.create({
  baseURL: `${API_CONFIG.baseURL}/`, // Uses environment variable
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to add the auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('accessToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Enhanced Doctor Onboarding API
export const doctorOnboardingApi = {
  // Get onboarding state
  getState: () => api.get('/doctor/onboarding/state/'),
  
  // Advance to next step
  advance: (step) => api.post('/doctor/onboarding/advance/', { step }),
  
  // Submit steps
  submitBasic: (data) => api.post('/doctor/onboarding/basic/', data),
  submitDocuments: (data) => api.post('/doctor/onboarding/documents/', data),
  submitClinic: (data) => api.post('/doctor/onboarding/clinic/', data),
  submitAvailability: (data) => api.post('/doctor/onboarding/availability/', data),
  submitBilling: (data) => api.post('/doctor/onboarding/billing/', data),
  
  // Verification
  submitVerification: (data) => api.post('/doctor/verifications/submit/', data),
  getVerificationStatus: () => api.get('/doctor/verifications/'),
};

// Admin verification API
export const adminVerificationApi = {
  getPending: () => api.get('/admin/verifications/'),
  review: (id, data) => api.patch(`/admin/verifications/${id}/review/`, data),
};

// Welcome/onboarding API for pre-configured doctors
export const magicLinkApi = {
  validateToken: (token) => api.post('/doctors/welcome/validate_token/', { token }),
  completeSetup: (token, password) => api.post('/doctors/welcome/complete_setup/', { token, password }),
};

// Admin doctor management API
export const adminDoctorApi = {
  listDoctors: (params) => api.get('/doctors/admin/doctors/list_doctors/', { params }),
  createMagicLink: (doctorId) => api.post(`/doctors/admin/doctors/${doctorId}/create_magic_link/`),
  startTrial: (doctorId) => api.post(`/doctors/admin/doctors/${doctorId}/start_trial/`),
  bypassOnboarding: (doctorId) => api.post(`/doctors/admin/doctors/${doctorId}/bypass_onboarding/`),
};

// Legacy API functions
export const getDoctors = async () => {
  try {
    const response = await api.get('doctors/');
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export default api;
